package com.rainbowclubs.rainbow.presentation.common.bottomNavBar

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.NavigationBar
import androidx.compose.material3.NavigationBarItem
import androidx.compose.material3.NavigationBarItemDefaults
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.rainbowclubs.rainbow.presentation.theme.RainbowClubTheme
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import rainbowclubs.composeapp.generated.resources.Res
import rainbowclubs.composeapp.generated.resources.home_icon_cd
import rainbowclubs.composeapp.generated.resources.ic_clubs
import rainbowclubs.composeapp.generated.resources.ic_home
import rainbowclubs.composeapp.generated.resources.ic_messages
import rainbowclubs.composeapp.generated.resources.ic_more
import rainbowclubs.composeapp.generated.resources.messages_icon_cd
import rainbowclubs.composeapp.generated.resources.more_icon_cd
import rainbowclubs.composeapp.generated.resources.nav_club
import rainbowclubs.composeapp.generated.resources.nav_home
import rainbowclubs.composeapp.generated.resources.nav_messages
import rainbowclubs.composeapp.generated.resources.nav_more

enum class BottomNavItem {
    Home, Club, Messages, More
}

@Composable
fun BottomNavBar(
    selectedItem: BottomNavItem,
    onHomeClick: () -> Unit,
    onClubClick: () -> Unit,
    onMessagesClick: () -> Unit,
    onMoreClick: () -> Unit,
    modifier: Modifier = Modifier,
) {
    NavigationBar(
        containerColor = Color.Transparent,
        modifier = modifier.height(80.dp).clip(RoundedCornerShape(8.dp)).background(
            MaterialTheme.colorScheme.surface
        ),
        tonalElevation = 0.dp,
    ) {
        NavigationBarItem(
            icon = {
                Icon(
                    painterResource(Res.drawable.ic_home),
                    contentDescription = stringResource(Res.string.home_icon_cd),
                    modifier = Modifier.size(24.dp),
                )
            },
            label = { Text(stringResource(Res.string.nav_home), fontSize = 12.sp) },
            selected = selectedItem == BottomNavItem.Home,
            onClick = onHomeClick,
            colors = NavigationBarItemDefaults.colors(
                selectedTextColor = MaterialTheme.colorScheme.primary,
                selectedIconColor = MaterialTheme.colorScheme.primary,
                unselectedIconColor = MaterialTheme.colorScheme.outline,
                unselectedTextColor = MaterialTheme.colorScheme.outline,
            ),
        )
        NavigationBarItem(
            icon = {
                Icon(
                    painterResource(Res.drawable.ic_clubs),
                    contentDescription = null,
                    modifier = Modifier.size(24.dp),
                )
            },
            label = { Text(stringResource(Res.string.nav_club), fontSize = 12.sp) },
            selected = selectedItem == BottomNavItem.Club,
            onClick = onClubClick,
            colors = NavigationBarItemDefaults.colors(
                selectedTextColor = MaterialTheme.colorScheme.primary,
                selectedIconColor = MaterialTheme.colorScheme.primary,
                unselectedIconColor = MaterialTheme.colorScheme.outline,
                unselectedTextColor = MaterialTheme.colorScheme.outline,
                indicatorColor = Color.Transparent,
            ),
        )
        NavigationBarItem(
            icon = {
                Icon(
                    painterResource(Res.drawable.ic_messages),
                    contentDescription = stringResource(Res.string.messages_icon_cd),
                    modifier = Modifier.size(24.dp),
                )
            },
            label = { Text(stringResource(Res.string.nav_messages), fontSize = 12.sp) },
            selected = selectedItem == BottomNavItem.Messages,
            onClick = onMessagesClick,
            colors = NavigationBarItemDefaults.colors(
                selectedTextColor = MaterialTheme.colorScheme.primary,
                selectedIconColor = MaterialTheme.colorScheme.primary,
                unselectedIconColor = MaterialTheme.colorScheme.outline,
                unselectedTextColor = MaterialTheme.colorScheme.outline,
            ),
        )
        NavigationBarItem(
            icon = {
                Icon(
                    painterResource(Res.drawable.ic_more),
                    contentDescription = stringResource(Res.string.more_icon_cd),
                    modifier = Modifier.size(24.dp),
                )
            },
            label = { Text(stringResource(Res.string.nav_more), fontSize = 12.sp) },
            selected = selectedItem == BottomNavItem.More,
            onClick = onMoreClick,
            colors = NavigationBarItemDefaults.colors(
                selectedTextColor = MaterialTheme.colorScheme.primary,
                selectedIconColor = MaterialTheme.colorScheme.primary,
                unselectedIconColor = MaterialTheme.colorScheme.outline,
                unselectedTextColor = MaterialTheme.colorScheme.outline,
            ),
        )
    }
}

@Preview
@Composable
private fun BottomNavBarPreview() {
    RainbowClubTheme {
        BottomNavBar(
            selectedItem = BottomNavItem.Home,
            onHomeClick = {},
            onClubClick = {},
            onMessagesClick = {},
            onMoreClick = {},
        )
    }
}
